import classes from "./ArrowBtn.module.css";
import ArrowBlue from "../../../images/orderInformation/arrowBlueRight.svg";
import ArrowGray from "../../../images/orderInformation/arrowGrayRight.svg";

export function ArrowBtn({ onClick, disabled, direction = "right" }) {
  // pick icon color based on disabled state
  const iconSrc = disabled ? ArrowGray : ArrowBlue;

  // rotate left arrow
  const rotation = direction === "left" ? "rotate(180deg)" : "rotate(0deg)";

  return (
    <button className={classes.btn} disabled={disabled} onClick={onClick}>
      <img
        src={iconSrc}
        alt={`${direction} arrow`}
        style={{ transform: rotation, transition: "transform 0.3s" }}
      />
    </button>
  );
}
